<template>
  <div class="footer">
    <p
      class="disclaimer"
      v-if="disclaimer && disclaimer.show"
      v-html="disclaimer.message"
    />

    <div class="footer--cols">
      <div class="col-1">
        <p>
          <a
            href="https://banxa.com/legal-compliance/?_ga=2.92118746.1754880715.1655770156-1500146562.1655770156"
            target="_blank"
            rel="noopener"
          >{{ $t('Footer.label.legalAndCompliance') }}</a
          >
          <a
            v-if="!geoIsUK"
            href="https://support.banxa.com/?_ga=2.171768416.1754880715.1655770156-1500146562.1655770156"
            target="_blank"
            rel="noopener"
          > | {{ $t('Footer.label.supportCenter') }}</a
          >
        </p>

        <p>
          <span>{{ $t('Footer.label.authorised') }}</span>
        </p>
      </div>
      <div class="col-2">
        <!-- <p>
          &copy; {{ currentYear() }} {{ entityDetails.desc }} Trading as Banxa.
        </p> -->
        <p>
          The relevant Banxa entity you're contracting with and the relevant
          <br />contact details are set out in clause 19(a) of
          <a
            href="https://banxa.com/terms-of-use"
            target="_blank"
            rel="noopener"
          >Terms and Conditions</a
          >.
        </p>
        <!-- <p>{{ entityDetails.prefix }}: {{ entityDetails.address }}</p> -->
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useOrderFormStore } from '@/stores/forms/orderFormStore';
import { useGlobalStore } from '@/stores/globalStore';
import { useI18n } from 'vue-i18n';
import { checkGeo } from '@/composables/helpers/useDetectedGeo';


const { t } = useI18n();
const globalStore = useGlobalStore();
const orderStore = useOrderFormStore();
const geoIsUK = computed(() => checkGeo('GB'));

const getEntityObject = (operator) => {
  const opObject = {
    prefix: '',
    desc: '',
    address: '',
  };

  switch (operator) {
    case 'riv':
      opObject.prefix = 'Registered Office';
      opObject.desc = 'Richmond Internet Ventures Corporation';
      opObject.address = 'Suite 1103 - 11871 Horseshoe Way, Richmond, British Columbia V7A 5H5, Canada';
      break;
    case 'eiv':
      opObject.prefix = 'Registered Office';
      opObject.desc = 'EU Internet Ventures BV';
      opObject.address = 'Piet Heinkade 93B, 1019GM, Amsterdam, The Netherlands.';
      break;
    default:
      opObject.prefix = 'Head Office';
      opObject.desc = 'Global Internet Ventures Pty Ltd';
      opObject.address = 'L2 2-6 Gwynne Street, Cremorne, Victoria 3121, Australia';
      break;
  }

  return opObject;
};

const entityDetails = computed(() => {
  const paymentList = orderStore.getActiveStorePaymentData;
  const selectedPayment = orderStore.getActiveStore.getFormPayload.payment;
  const paymentDetail = paymentList.find(
    (order) => order.code.toLowerCase() === selectedPayment,
  );
  return getEntityObject(paymentDetail?.operator);
});

const currentYear = () => new Date().getFullYear();

const disclaimer = computed(() => {
  // TODO: Add condition for specific merchant
  let geoCheck = false;
  if (globalStore?.getDetectedGeo) {
    geoCheck = globalStore?.getDetectedGeo?.country_code?.toUpperCase() === 'US';
  }
  return {
    show: geoCheck || true,
    message: t('Footer.label.disclaimer'),
  };
});
</script>

<style lang="scss">
.footer {
  width: 100%;
  background: rgba(0, 0, 0, 0.2);
  padding: 2.4rem 3.5rem;
  margin: 0;
  display: flex;
  flex-direction: column;
  margin-top: 2rem; //.main-content > div has 2rem

  &--cols {
    display: grid;
    grid-template-columns: 0.75fr 1fr;
    grid-template-rows: 1fr;
    justify-content: center;
    align-items: center;
    padding-top: 2.4rem;
    .col-2 {
      text-align: right;
    }
  }

  p,
  span,
  a {
    color: var(--footer-text-color);
  }

  &.disclaimer {
    color: var(--footer-text-color);
    margin-bottom: 2rem;
  }
}
</style>
